import React from 'react';

interface DataVaultContextValue {
  surveyId: number | null;
  targetUserId: number;
  isOnBehalf: boolean;
  actingOnMemberId: number | null;
}

const DataVaultContext = React.createContext<DataVaultContextValue>({
  surveyId: null,
  targetUserId: 0,
  isOnBehalf: false,
  actingOnMemberId: null,
});

export const useDataVault = (): DataVaultContextValue =>
  React.useContext(DataVaultContext);
export default DataVaultContext;
